import React from 'react';
import { Table, Button, Space, Typography, Tag } from 'antd';
import { EyeOutlined, DeleteOutlined, SettingOutlined, MailOutlined } from '@ant-design/icons';

const { Text } = Typography;

const GhannejjaGoddaTab = ({ 
  applications, 
  loading, 
  canDelete,
  onRefresh, 
  onView, 
  onDelete,
  onNotificationClick,
  onEmailTemplatesClick
}) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
      width: 70,
    },
    {
      title: 'Name',
      key: 'name',
      render: (_, record) => `${record.fName} ${record.lName}`,
      sorter: (a, b) => `${a.fName} ${a.lName}`.localeCompare(`${b.fName} ${b.lName}`),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      width: 70,
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: 'Locality',
      dataIndex: 'localityName',
      key: 'localityName',
      sorter: (a, b) => (a.localityName || '').localeCompare(b.localityName || ''),
    },
    {
      title: 'Payment',
      dataIndex: 'hasPaid',
      key: 'hasPaid',
      width: 100,
      render: (hasPaid) => (
        <Tag color={hasPaid ? 'success' : 'warning'}>
          {hasPaid ? 'Paid' : 'Pending'}
        </Tag>
      ),
      filters: [
        { text: 'Paid', value: true },
        { text: 'Pending', value: false },
      ],
      onFilter: (value, record) => record.hasPaid === value,
    },
    {
      title: 'Submitted',
      dataIndex: 'submittedAt',
      key: 'submittedAt',
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.submittedAt) - new Date(b.submittedAt),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => onView(record.id)}
            size="small"
            block
          >
            View
          </Button>
          {canDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record.id)}
              size="small"
              block
            >
              Delete
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button 
            onClick={onRefresh}
            loading={loading}
          >
            Refresh
          </Button>
          <Text type="secondary">
            Total Applications: {applications.length}
          </Text>
        </Space>
        <Space>
          {onEmailTemplatesClick && (
            <Button
              icon={<MailOutlined />}
              onClick={onEmailTemplatesClick}
            >
              Email Templates
            </Button>
          )}
          <Button
            icon={<SettingOutlined />}
            onClick={onNotificationClick}
          >
            Notification Settings
          </Button>
        </Space>
      </div>
      
      <Table
        columns={columns}
        dataSource={applications}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} applications`,
        }}
        scroll={{ x: true }}
      />
    </>
  );
};

export default GhannejjaGoddaTab;
